import { Get } from "services";
import { ApiPath } from "paths";

export const getMeasurements = async ({ venueId }) => {
  const res = await Get(`${ApiPath.GET_MEASUREMENTS(venueId)}`);
  return res;
};
